import { Params } from '@angular/router';
import { Injectable } from '@angular/core';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';

@Injectable({
	providedIn: 'root'
})
export class DocViewerParamReader {
	public docId: string;
	public page: string;
	public fromSearch: boolean;
	public fromAutoRedaction: boolean;
	public prodId: string;
	public reviewSetId: string;
	public diffDocId: string;
	public redactionApplied: boolean;
	public redactionStatus: boolean;
	public annotationApplied: boolean;
	public annotationStatus: boolean;

	constructor(private docViewerStore: DocViewerStore) {
	}

	public read(params: Params) {
		this.docId = params['DocId'];
		if (!this.docId) throw Error('Doc Viewer cannot operate without DocId parameter.'); // Log instead
		this.page = params['p'] ? params['p'] : '1';
		this.fromSearch = params['s'] === '1';
		this.fromAutoRedaction = params['ar'] === '1';
		this.prodId = params['prodId'];
		this.reviewSetId = params['ReviewSetId'];
		this.diffDocId = params['DiffDocId'];
		this.redactionApplied = params['RedactionApplied'];
		this.redactionStatus = params['RedactionStatus'] === '1';
		this.annotationApplied = params['AnnotationApplied'];
		this.annotationStatus = params['AnnotationStatus'] === '1';

		this.docViewerStore.updateState((currentState) => {
			currentState.legacyParams.page = params['p'] ? params['p'] : '1';
			currentState.legacyParams.fromSearch = params['s'] === '1';
			currentState.legacyParams.fromAutoRedaction = params['ar'] === '1';
			currentState.legacyParams.prodId = params['prodId'];
			currentState.legacyParams.reviewSetId = params['ReviewSetId'];
			currentState.legacyParams.diffDocId = params['DiffDocId'];
			currentState.legacyParams.redactionApplied = params['RedactionApplied'];
			currentState.legacyParams.redactionStatus = params['RedactionStatus'] === '1';
			currentState.legacyParams.annotationApplied = params['AnnotationApplied'];
			currentState.legacyParams.annotationStatus = params['AnnotationStatus'] === '1';
			return currentState;
		})

	}

	public changeDocTo(docId: string): any {
		this.docId = docId;
		this.page = null;
		this.prodId = null;
		this.redactionApplied = false;
		this.redactionStatus = false;
		this.annotationApplied = false;
		this.annotationStatus = false;

		const params: { [k: string]: any } = {
			DocId: docId
		};

		if (this.fromSearch) params.s = '1';
		if (this.fromAutoRedaction) params.ar = '1';
		if (this.reviewSetId) params.ReviewSetId = this.reviewSetId;
		if (this.diffDocId) params.DiffDocId = this.diffDocId;

		return params;
	}
}
